import { IconButton, Tooltip } from '@chakra-ui/react';
import { iconStyling } from './agGridStyles';

const TableIconButton = ({ icon, onClick, tooltip, isDisabled }) => {
    return (
        <Tooltip label={tooltip}>
            <IconButton
                sx={iconStyling}
                variant="ghost"
                isRound={true}
                size="sm"
                onClick={onClick}
                isDisabled={isDisabled}>
                {icon}
            </IconButton>
        </Tooltip>
    );
};

export default TableIconButton;
